import {TextField} from "@mui/material";
import {ImperialDistance} from "../../misc/ImperialDistance";
import {genericDistanceParser} from "../../misc/scroller/Table";
import {useProjectUnitSystem} from "../project/shopdrawing/ProjectName";
import {MetricDistance} from "../../misc/MetricDistance";

export function DimensionInput2(props: {
    label: string;
    value: string;
    inches?: boolean;
    disabled?: boolean;
    onChange(value: string): void;
    blankPlaceholder?: string;
}) {
    const units = useProjectUnitSystem()

    return (
        <TextField
            fullWidth
            label={props.label}
            InputLabelProps={{shrink: true}}
            size="small"
            variant="outlined"
            disabled={props.disabled}
            value={props.value}
            placeholder={props.blankPlaceholder}
            onBlur={e => {
                try {
                    if(props.inches) {
                        props.onChange(ImperialDistance.parse(e.target.value).toInchesString());
                        return;
                    }

                    let v: ImperialDistance | MetricDistance
                    if(units === "metric") {
                        v = MetricDistance.parse(e.target.value);
                    } else if (units === "imperial") {
                        v = ImperialDistance.parse(e.target.value);
                    } else {
                        v = genericDistanceParser(e.target.value);
                    }

                    props.onChange(v.toString());
                } catch (e) {}
            }}
            onChange={e => props.onChange(e.target.value)}
        />
    )
}